export default "__VITE_ASSET__mNLLO3Qn__"